export default "__VITE_ASSET__31b8a57b__"